// Check if plan has a timeline
import * as TabilityTypes from 'types';

export const isTabilityUser = (user: TabilityTypes.User): boolean => {
  return user && user.confirmed_at !== null && user.email.split('@')[1] === 'tability.io';
};
